/* eslint-disable quote-props */

export const categories = {
  "Kijken en luisteren": [
    "Concert",
    "Theatervoorstelling",
    "Lezing of congres",
    "Dansvoorstelling",
    "Festival",
    "Toeristisch evenement",
    "Film",
    "Sportwedstrijd bekijken",
  ],
  Doen: [
    "Cursus of workshop",
    "Sportactiviteit",
    "Kamp of vakantie",
    "Begeleide uitstap of rondleiding",
    "Fiets- of wandelroute",
    "Spel of quiz",
    "Party of fuif",
    "Kermis of feestelijkheid",
    "Congres of studiedag",
    "Eten en drinken",
    "Thema of pretpark",
    "Jeugdhuis of jeugdcentrum",
    "Cultuur- of ontmoetingscentrum",
    "Discotheek",
    "Bibliotheek of documentatiecentrum",
    "Bioscoop",
    "Horeca",
  ],
  Bezoeken: [
    "Openbare ruimte",
    "Tentoonstelling",
    "Markt of braderie",
    "Natuurgebied of park",
    "Beurs",
    "Monument",
    "Opendeurdag",
    "Recreatiedomein of centrum",
    "Park of tuin",
    "Archeologische Site",
    "School of onderwijscentrum",
    "Sportcentrum",
    "Winkel",
    "Museum of galerij",
    "Zaal of expohal",
  ],
};

export const municipalities = [
  { key: "1000-brussel", postal: "1000", name: "Brussel" },
  { key: "1020-laken", postal: "1020", name: "Laken" },
  { key: "1030-schaarbeek", postal: "1030", name: "Schaarbeek" },
  { key: "1040-etterbeek-brussel", postal: "1040", name: "Etterbeek" },
  { key: "1050-elsene-brussel", postal: "1050", name: "Elsene" },
  { key: "1060-sint-gillis-brussel", postal: "1060", name: "Sint-Gillis" },
  { key: "1070-anderlecht-brussel", postal: "1070", name: "Anderlecht" },
  {
    key: "1080-sint-jans-molenbeek-brussel",
    postal: "1080",
    name: "Sint-Jans-Molenbeek",
  },
  { key: "1081-koekelberg-brussel", postal: "1081", name: "Koekelberg" },
  {
    key: "1082-sint-agatha-berchem-brussel",
    postal: "1082",
    name: "Sint-Agatha-Berchem",
  },
  { key: "1083-ganshoren-brussel", postal: "1083", name: "Ganshoren" },
  { key: "1090-jette-brussel", postal: "1090", name: "Jette" },
  {
    key: "1120-neder-over-heembeek-brussel",
    postal: "1120",
    name: "Neder-Over-Heembeek",
  },
  { key: "1130-haren-brussel", postal: "1130", name: "Haren" },
  { key: "1140-evere-brussel", postal: "1140", name: "Evere" },
  {
    key: "1150-sint-pieters-woluwe-brussel",
    postal: "1150",
    name: "Sint-Pieters-Woluwe",
  },
  { key: "1160-oudergem-brussel", postal: "1160", name: "Oudergem" },
  {
    key: "1170-watermaal-bosvoorde-brussel",
    postal: "1170",
    name: "Watermaal-Bosvoorde",
  },
  { key: "1180-ukkel-brussel", postal: "1180", name: "Ukkel" },
  { key: "1190-vorst-brussel", postal: "1190", name: "Vorst" },
  {
    key: "1200-sint-lambrechts-woluwe-brussel",
    postal: "1200",
    name: "Sint-Lambrechts-Woluwe",
  },
  {
    key: "1210-sint-joost-ten-node-brussel",
    postal: "1210",
    name: "Sint-Joost-Ten-Node",
  },
];

export const periods = [
  { key: "today", value: "Vandaag" },
  { key: "tomorrow", value: "Morgen" },
  { key: "thisweekend", value: "Dit weekend" },
  { key: "next7days", value: "Komende 7 dagen" },
  { key: "next14days", value: "Komende 14 dagen" },
  { key: "next30days", value: "Komende 30 dagen" },
];
